// src/pages/Dashboard/Admin/SeasonStats/components/SeasonStatsControlsCard.jsx

import React from "react";

import {
  FaCalendarAlt,
  FaEdit,
  FaMagic,
  FaPlus,
  FaSyncAlt,
  FaTrash,
} from "react-icons/fa";

import {
  getSourceClass,
  getSourceLabel,
} from "../utils/seasonStatsDashboardUtils";

export default function SeasonStatsControlsCard({
  seasons = [],
  selectedSeasonId,
  setSelectedSeasonId,
  currentSeason,
  loading,
  generating,
  deletingId,
  onRefresh,
  onGenerate,
  onAdd,
  onEdit,
  onDelete,
}) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="flex flex-col gap-5 xl:flex-row xl:items-end xl:justify-between">
          <div className="min-w-0 flex-1">
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Saison analysée
            </p>

            <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
              Choisir une saison
            </h2>

            <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
              Sélectionnez un historique existant ou créez un
              nouveau snapshot.
            </p>

            <div className="mt-4 flex max-w-xl flex-col gap-3 sm:flex-row sm:items-center">
              <div className="relative flex-1">
                <FaCalendarAlt className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

                <select
                  value={selectedSeasonId || ""}
                  onChange={(event) =>
                    setSelectedSeasonId(
                      event.target.value
                        ? Number(event.target.value)
                        : null,
                    )
                  }
                  className="w-full appearance-none rounded-2xl border border-slate-200 bg-white py-2.5 pl-10 pr-3 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
                >
                  <option value="">
                    Sélectionner une saison
                  </option>

                  {seasons.map((item) => (
                    <option
                      key={item.id}
                      value={item.id}
                    >
                      {item.season}
                    </option>
                  ))}
                </select>
              </div>

              {currentSeason ? (
                <span
                  className={`inline-flex shrink-0 rounded-full px-3 py-1.5 text-xs font-bold ring-1 ${getSourceClass(
                    currentSeason.source,
                  )}`}
                >
                  {getSourceLabel(
                    currentSeason.source,
                  )}
                </span>
              ) : null}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap sm:justify-end">
            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
            >
              <FaSyncAlt
                className={
                  loading ? "animate-spin" : ""
                }
              />
              Actualiser
            </button>

            <button
              type="button"
              onClick={onGenerate}
              disabled={generating}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-3 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-emerald-700 disabled:opacity-60"
            >
              <FaMagic />
              {generating
                ? "Génération..."
                : "Générer la saison"}
            </button>

            <button
              type="button"
              onClick={onAdd}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-3 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-[#012f6c]"
            >
              <FaPlus />
              Saisie manuelle
            </button>

            <button
              type="button"
              onClick={onEdit}
              disabled={!currentSeason}
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-indigo-200 bg-indigo-50 px-3 py-2 text-sm font-bold text-indigo-700 transition hover:bg-indigo-100 disabled:opacity-40 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300"
            >
              <FaEdit />
              Modifier
            </button>

            <button
              type="button"
              onClick={onDelete}
              disabled={
                !currentSeason ||
                deletingId === currentSeason?.id
              }
              className="col-span-2 inline-flex items-center justify-center gap-2 rounded-2xl border border-rose-200 bg-rose-50 px-3 py-2 text-sm font-bold text-rose-700 transition hover:bg-rose-100 disabled:opacity-40 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300 sm:col-span-1"
            >
              <FaTrash />
              Supprimer
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}